function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "b",
  x1: "40.903%",
  x2: "89.258%",
  y1: "26.718%",
  y2: "87.531%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FD2A51"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF4B6D"
})), React.createElement("path", {
  id: "a",
  d: "M0 0h1920v786H0z"
}), React.createElement("linearGradient", {
  id: "c",
  x1: "25.698%",
  x2: "74.815%",
  y1: "73.956%",
  y2: "57.211%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FF2A51"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF4B6D"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("use", {
  fill: "url(#b)",
  xlinkHref: "#a"
}), React.createElement("path", {
  fill: "url(#c)",
  mask: "url(#d)",
  opacity: 0.775,
  transform: "matrix(-1 0 0 1 1091 0)",
  d: "M1091 282L0 785h1091z"
}));

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 786
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTkyMCIgaGVpZ2h0PSI3ODYiIHZpZXdCb3g9IjAgMCAxOTIwIDc4NiI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImhlYWRlci1yZWQtYiIgeDE9IjQwLjkwMyUiIHgyPSI4OS4yNTglIiB5MT0iMjYuNzE4JSIgeTI9Ijg3LjUzMSUiPgogICAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjRkQyQTUxIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI0ZGNEI2RCIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxyZWN0IGlkPSJoZWFkZXItcmVkLWEiIHdpZHRoPSIxOTIwIiBoZWlnaHQ9Ijc4NiIvPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJoZWFkZXItcmVkLWMiIHgxPSIyNS42OTglIiB4Mj0iNzQuODE1JSIgeTE9IjczLjk1NiUiIHkyPSI1Ny4yMTElIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI0ZGMkE1MSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNGRjRCNkQiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8bWFzayBpZD0iaGVhZGVyLXJlZC1kIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjaGVhZGVyLXJlZC1hIi8+CiAgICA8L21hc2s+CiAgICA8dXNlIGZpbGw9InVybCgjaGVhZGVyLXJlZC1iKSIgeGxpbms6aHJlZj0iI2hlYWRlci1yZWQtYSIvPgogICAgPHBvbHlnb24gZmlsbD0idXJsKCNoZWFkZXItcmVkLWMpIiBwb2ludHM9IjEwOTEgMjgyIDAgNzg1IDI3MSA3ODUgMTA5MSA3ODUiIG1hc2s9InVybCgjaGVhZGVyLXJlZC1kKSIgb3BhY2l0eT0iLjc3NSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMTA5MSAwKSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgComponent as ReactComponent };